import InvoiceProductTypeApi from './Api';
import * as ActionTypes from './ActionTypes';
import { IInvoiceProductType, ISite } from './Types';

function listLoadedSuccess(productTypes: any) {
    return {
        type: ActionTypes.LIST_INVOICE_PRODUCT_TYPES_SUCCESS,
        result: productTypes
    };
}

function getSuccess(item: IInvoiceProductType) {
    return { type: ActionTypes.GET_INVOICE_PRODUCT_TYPE_SUCCESS, result: item };
}

function editSuccess(item: IInvoiceProductType) {
    return {
        type: ActionTypes.EDIT_INVOICE_PRODUCT_TYPE_SUCCESS,
        result: item
    };
}

function createSuccess(item: IInvoiceProductType) {
    return {
        type: ActionTypes.CREATE_INVOICE_PRODUCT_TYPE_SUCCESS,
        result: item
    };
}

function loadSuccess(item: { sites: ISite[] }) {
    return {
        type: ActionTypes.LOAD_INVOICE_PRODUCT_TYPE_SUCCESS,
        result: item
    };
}

function deleteSuccess(id: number) {
    return {
        type: ActionTypes.DELETE_INVOICE_PRODUCT_TYPE_SUCCESS,
        result: id
    };
}

export function load() {
    return (dispatch: (result: any) => void) =>
        InvoiceProductTypeApi.load().then((result) => {
            dispatch(loadSuccess(result));
        });
}

export function get(id: number) {
    return (dispatch: (result: any) => void) =>
        InvoiceProductTypeApi.get(id).then((result) => {
            dispatch(getSuccess(result));
        });
}

export function deleteItem(id: number) {
    return (dispatch: (result: any) => void) =>
        InvoiceProductTypeApi.delete(id).then((result) => {
            dispatch(deleteSuccess(id));
        });
}

export function edit(id: number, name: string, country: number, site: number, isSystemDefault: boolean) {
    return (dispatch: (result: any) => void) =>
        InvoiceProductTypeApi.edit(id, name, country, site, isSystemDefault).then((result) => {
            dispatch(editSuccess(result));
        });
}

export function create(name: string, site: number) {
    return (dispatch: (result: any) => void) =>
        InvoiceProductTypeApi.create(name, site).then((result) => {
            dispatch(createSuccess(result));
        });
}

export function list() {
    return (dispatch: (result: any) => void) =>
        InvoiceProductTypeApi.list().then((result) => {
            dispatch(listLoadedSuccess(result));
        });
}
